import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class PossibleDuplicateLeadsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: [{
                id: 'b7f0c2de-5a3e-4c1a-9a4e-3f6f1f0d2a11',
                fantasy_name: "Michael's Bakery",
                business_name: 'Dunder Mifflin',
                stage: 'NEGOTIATION',
                commercial_channel: 'Horeca',
                responsible: 'closer@saporedipane.com',
                creator: 'lead-creator@dundermifflin.com',
                matched_by: ['NAME', 'TAXPAYER_IDENTIFICATION_NUMBER'],
            }],
            errors: [],
        };
    }

    possibleDuplicateLeads() {
        return this.content().map((possibleDuplicateLead) => ({
            id: possibleDuplicateLead.id,
            fantasyName: possibleDuplicateLead.fantasy_name,
            businessName: possibleDuplicateLead.business_name,
            stage: possibleDuplicateLead.stage,
            commercialChannel: possibleDuplicateLead.commercial_channel,
            responsible: possibleDuplicateLead.responsible,
            creator: possibleDuplicateLead.creator,
            matchedBy: possibleDuplicateLead.matched_by,
        }));
    }
}
